import React from 'react';
// import { storeDict, salesChannelDict } from 'src/tools/urlMap';
import { EnumCategory } from 'src/types/common/resources';
import { get } from 'lodash';
import { salesChannelRoutes, storeRoutes } from 'src/tools/urlMap';
import {
  I18nContext,
  baseURL,
  //languageList,
} from '../../locale/IntlProvider/IntlProvider';
import { useRequest } from 'ahooks';
import { useRouteMatch } from 'react-router-dom';
const dict = {
  [storeRoutes.permission]: EnumCategory.Dashboard, //!!!!!

  [storeRoutes.storeVoucherEdit]: EnumCategory.Voucher,
  [storeRoutes.storeVoucherList]: EnumCategory.Voucher,

  [storeRoutes.orderList]: EnumCategory.Order,
  [storeRoutes.orderCreate]: EnumCategory.Order,
  [storeRoutes.orderDetail]: EnumCategory.Order,
  [storeRoutes.orderShoppingCartList]: EnumCategory.Order,
  [storeRoutes.orderShoppingCartDetail]: EnumCategory.Order,
  [storeRoutes.orderSubscriptionBuyList]: EnumCategory.Order,
  [storeRoutes.orderSubscriptionBuyDetail]: EnumCategory.Order,
  [storeRoutes.orderGiftCardList]: EnumCategory.Order,
  [storeRoutes.orderGiftCardDetail]: EnumCategory.Order,

  [storeRoutes.simpleProductDetail]: EnumCategory.Products,
  [storeRoutes.productSetDetail]: EnumCategory.Products,
  [storeRoutes.virtualProductDetail]: EnumCategory.Products,
  [storeRoutes.storeStockEdit]: EnumCategory.Products,
  [storeRoutes.inventoryEdit]: EnumCategory.Products,
  [storeRoutes.allInventory]: EnumCategory.Products,
  [storeRoutes.reviewEdit]: EnumCategory.Products,
  [storeRoutes.storeProductList]: EnumCategory.Products,
  [storeRoutes.inventoryList]: EnumCategory.Products,
  [storeRoutes.storeStockList]: EnumCategory.Products,
  [storeRoutes.reviewList]: EnumCategory.Products,

  [storeRoutes.communicationDetail]: EnumCategory.Communication,
  [storeRoutes.communicationList]: EnumCategory.Communication,

  [storeRoutes.reportSubscriptionDetail]: EnumCategory.Analytics,
  [storeRoutes.reportSubscriptionList]: EnumCategory.Analytics,
  [storeRoutes.reportDetail]: EnumCategory.Analytics,
  [storeRoutes.reportList]: EnumCategory.Analytics,

  [storeRoutes.salesChannelList]: EnumCategory.SalesChannelGeneral,

  [storeRoutes.storeSettings]: EnumCategory.Settings,
  [storeRoutes.storeFileLibraryList]: EnumCategory.Settings,
  [storeRoutes.storeFileLibraryDetail]: EnumCategory.Settings,
  [storeRoutes.storeDetail]: EnumCategory.Settings,
  [storeRoutes.storeDeveloperSetting]: EnumCategory.Settings,
  [storeRoutes.storeLinkLibraryList]: EnumCategory.Settings,
  [storeRoutes.storeLinkLibraryDetail]: EnumCategory.Settings,
  [storeRoutes.storeInvoice]: EnumCategory.Settings,
  [storeRoutes.storeCurrency]: EnumCategory.Settings,
  [storeRoutes.storeProductSetting]: EnumCategory.Settings,
  [storeRoutes.storeOrderSetting]: EnumCategory.Settings,
  [storeRoutes.storeTaxList]: EnumCategory.Settings,
  [storeRoutes.storeTaxDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogistics]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsWarehouseDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsParcelLockerDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsPickupLocationDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsDeliveryMethodDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsDestinationLanguagesDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsCourierAccountDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsPackingSlipDetail]: EnumCategory.Settings,
  [storeRoutes.storeLogisticsPackageSetting]: EnumCategory.Settings,
  [storeRoutes.storePaymentDetail]: EnumCategory.Settings,
  [storeRoutes.storePaymentList]: EnumCategory.Settings,
  [storeRoutes.storeLocalisation]: EnumCategory.Settings,
  [storeRoutes.store3rdApi]: EnumCategory.Settings,
  [storeRoutes.storeTagManager]: EnumCategory.Settings,
  [storeRoutes.storeCommunicationList]: EnumCategory.Settings,
  [storeRoutes.storeCommunicationGatewayDetail]: EnumCategory.Settings,
  [storeRoutes.storeCommunicationTemplateDetail]: EnumCategory.Settings,
  [storeRoutes.storePermissionList]: EnumCategory.Settings,
  [storeRoutes.storePermissionDetail]: EnumCategory.Settings,
  [storeRoutes.storeBilling]: EnumCategory.Settings,

  [storeRoutes.customerDatabaseList]: EnumCategory.Customers,
  [storeRoutes.customerList]: EnumCategory.Customers,
  [storeRoutes.customerDetail]: EnumCategory.Customers,
  [storeRoutes.customerDatabaseSetting]: EnumCategory.Customers,
  [storeRoutes.customerTagList]: EnumCategory.Customers,
  [storeRoutes.customerTagDetail]: EnumCategory.Customers,

  [storeRoutes.dashboard]: EnumCategory.Dashboard,

  [salesChannelRoutes.contentList]: EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorHomepage]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditor404Page]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorProductSearch]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorContentPageList]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelContentPageEditorPage]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorTabbar]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorShoppingCartPage]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorPromotion]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorProfilePage]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorAllProductPage]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelAppearanceEditorPage]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorNavigation]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorHeader]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorFooter]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorMegaMenu]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorAnimation]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorButton]:
    EnumCategory.SalesChannelContent,
  [salesChannelRoutes.salesChannelEditorText]: EnumCategory.SalesChannelContent,

  [salesChannelRoutes.productList]: EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.promotionTagList]: EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.promotionTagDetail]: EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.salesChannelProductsLinkProductDetail]:
    EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.salesChannelProductContent]:
    EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.salesChannelProductCustomization]:
    EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.salesChannelProductAlias]:
    EnumCategory.SalesChannelProduct,
  [salesChannelRoutes.salesChannelProductAliasEdit]:
    EnumCategory.SalesChannelProduct,

  [salesChannelRoutes.legalPageList]: EnumCategory.SalesChannelLegal,
  [salesChannelRoutes.legalPageDetail]: EnumCategory.SalesChannelLegal,
  [salesChannelRoutes.tcDetail]: EnumCategory.SalesChannelLegal,
  [salesChannelRoutes.tcList]: EnumCategory.SalesChannelLegal,

  [salesChannelRoutes.settings]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.invoiceSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.digitalMarketingSetting]:
    EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.currencySetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.logisticsSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.localisationSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.inventorySetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.languageSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.orderSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.cookieSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.paymentSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.checkoutSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.registrationSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.logoManagementSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.domainSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.domainDetailSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.taxSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.miniProgramSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.communicationSetting]: EnumCategory.SalesChannelSettings,
  [salesChannelRoutes.communicationTemplate]: EnumCategory.SalesChannelSettings,

  [salesChannelRoutes.maintenance]: EnumCategory.SalesChannelMaintenancePage,

  [salesChannelRoutes.categoryProducts]: EnumCategory.SalesChannelCategory,
  [salesChannelRoutes.categoryPages]: EnumCategory.SalesChannelCategory,

  [salesChannelRoutes.collectionList]:
    EnumCategory.SalesChannelProductCollection,
  [salesChannelRoutes.collectionDetail]:
    EnumCategory.SalesChannelProductCollection,

  [salesChannelRoutes.flashSalesList]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.flashSalesDetail]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.directDiscountDetail]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.directDiscountList]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.subscriptionBuyDetail]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.subscriptionBuyList]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.giftPurchaseDetail]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.giftPurchaseList]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.voucherList]: EnumCategory.SalesChannelDiscount,
  [salesChannelRoutes.voucherDetail]: EnumCategory.SalesChannelDiscount,
};
//const JSON13 = 'https://resource2.unifyxp.com/test/smaple.json';
// const JSON7 = 'https://resource2.unifyxp.com/test/7.json';
// const JSON25 = 'https://resource2.unifyxp.com/test/25.json';
import axios from 'axios';
const CancelToken = axios.CancelToken;

// const useDidMountEffect = (func, deps) => {
//   const didMount = React.useRef(false);

//   React.useEffect(() => {
//     if (didMount.current) func();
//     else didMount.current = true;
//   }, deps);
// };

const useI18n = () => {
  const { path } = useRouteMatch();
  const { i18n, lang, generalI18n } = React.useContext(I18nContext);
  const preK = dict[path];
  const k = `${preK}_${lang}`;
  return { ...(get(i18n, k) || {}), ...generalI18n };
};

const useRouterI18nHooks = ({ path, url }) => {
  const sources = React.useRef<any>({});
  const { i18n, setI18n, lang } = React.useContext(I18nContext);
  const category = dict[path];
  //console.log('category', category);

  // const l = useLocation();

  //const url = r.url;
  const getResData = (r) => {
    return get(r, 'data');
  };
  const { run, loading } = useRequest(
    (req, p) => {
      // console.log('p', p);
      return req();
    },
    {
      manual: true,
      throwOnError: true,
      onSuccess: (r, p) => {
        const k = p[1];
        try {
          delete sources.current[k];
        } catch (e) {
          console.error(e);
        }

        setI18n({ ...i18n, [k]: getResData(r) });
      },
      onError: (e) => {
        console.warn('e', e);
      },
    },
  );
  const {
    // run: runRest
  } = useRequest(
    (req, k) => {
      //console.log('p1111', p);
      return req;
    },
    {
      manual: true,
      onSuccess: (r, p) => {
        const ks = get(p, 1);
        const o = {};
        r.forEach((r, index) => {
          const k = ks[index];
          o[k] = getResData(r);
        });
        const validKs = Object.keys(o).filter((i) => !i18n[i]);
        const _o = {};
        validKs.forEach((i) => {
          _o[i] = o[i];
        });
        setI18n({ ...i18n, ..._o });
        try {
          ks.forEach((k) => {
            delete sources.current[k];
          });
        } catch (e) {
          console.error(e);
        }

        //  setI18n({ ...i18n, [k]: r });
      },
    },
  );
  const k = `${category}_${lang}`;
  //const otherLangs = languageList.filter((i) => i !== lang);
  //const otherKeys = otherLangs.map((i) => `${category}_${i}`);

  React.useEffect(() => {
    return () => {
      const sks = Object.keys(sources.current);
      sks.forEach((i) => {
        sources.current[i]('leave the page');
        delete sources.current[i];
      });
    };
  }, []);

  React.useEffect(() => {
    // console.log('i18n', i18n);
  }, [i18n]);
  //console.log(`${baseURL}${k}.json`);
  const fetchCurrentLanguage = () => {
    const req = () =>
      axios.get(`${baseURL}${k}.json`, {
        cancelToken: new CancelToken((cancel) => {
          sources.current[k] = cancel;
        }),
      });
    run(req, k);
  };

  React.useEffect(() => {
    //换页面
    if (!get(i18n, `${k}`)) {
      fetchCurrentLanguage();
      // sources.current[k]('换页啦');
    }
    //const nonDataKeys = otherKeys.filter((i) => !get(i18n, `${i}`));

    // setTimeout(() => {
    //   if (nonDataKeys.length > 0) {
    //     runRest(
    //       Promise.all(
    //         nonDataKeys.map((i) => {
    //           const req = axios.get(`${baseURL}${i}.json`, {
    //             cancelToken: new CancelToken((cancel) => {
    //               sources.current[i] = cancel;
    //             }),
    //           });
    //           return req;
    //         }),
    //       ),
    //       nonDataKeys,
    //     );
    //   }
    //   // runRest(Promise.all([axios.get(JSON25), axios.get(JSON25)]));
    // }, 2000);
  }, [category]);

  React.useEffect(() => {
    //换语言
    if (!get(i18n, `${k}`)) {
      try {
        if (sources.current[k]) {
          sources.current[k]();
        }
      } catch (e) {
        console.warn(e);
      }
      fetchCurrentLanguage();
    }
  }, [lang]);
  // useDidMountEffect(() => {
  //   window.portalI18n = null;
  //   location.reload();
  // }, [lang]);
  return { loading };
};

export { useRouterI18nHooks, useI18n };
